import PlayerCreatedMatches from '@commons/matches/player-created'
import React from 'react'

const PlayerCreated = () => {
  return <PlayerCreatedMatches isResult={true} />
}

export default PlayerCreated
